import React from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import Modal from "../common/CommonModal";
import PDCReceivedDocument from "./PDCReceivedDocument";

const PDCReceivedPrint = ({ pdcReceivedPrintDataFromAPI, setIsPDCReceivedPrint , isPDCReceivedPrint }) => {
  const onClose = () => {
    setIsPDCReceivedPrint(false);
  };

  console.log("pdcReceivedPrintDataFromAPI:", pdcReceivedPrintDataFromAPI);
  return (
    <Modal
      isOpen={isPDCReceivedPrint}
      onClose={() => setIsPDCReceivedPrint(false)}
      title={"PDC Received"}
      size="xxl"
      header={true}
    >
      <div className="flex flex-col items-center h-screen">
        <div className="w-full h-[82vh] border border-gray-300 mb-4">
          <PDFViewer width="100%" height="100%">
            <PDCReceivedDocument pdcReceivedPrintDataFromAPI={pdcReceivedPrintDataFromAPI} />
          </PDFViewer>
        </div>
      </div>
    </Modal>
  );
};

export default PDCReceivedPrint;
